import { HelpParameters, Help, HelpPanelColor } from "../../help/Help";
import { IHelpFactory } from "../../help/IHelpFactory";
import { MultigameParams } from "../../MultigameParams";
import { SlotGameInitData } from "../../SlotGameInitData";
import { IPanelFactory, PanelParams } from "../panel/IPanelFactory";
import { Panel, ButtonColors } from "../panel/panel";
import { RewardColor } from "../ScatterRandomAward/RewardOptionFactory";
import { SlotGameType1_2Screen } from "../SlotGameType1_2Screen";
import { IWinLinesFactory } from "../WinLines/IWinLinesFactory";
import { SquareWinLinesFactory } from "../WinLines/SquareWinLineFactory";
import { AudioManager} from "../../AudioManager";
import { Rect } from "../.././MyHelpers";
import { ResourceManager } from "../../ResourceManager/ResourceManager";
import {  FontResource } from "../../ResourceManager/FontResource";

	export class TikiBay_2Screen extends SlotGameType1_2Screen {

        //protected panelFactory:IPanelFactory = new TikiBayPanelFactory();
		protected override helpFactory:IHelpFactory = new TikiBayHelpFactory();
        

        //LED COLOR
		protected override ColorLed:string="36,255,149\n";
        
		
		constructor(multigameParams: MultigameParams, initData: SlotGameInitData) {
			super(multigameParams, initData, "TikiBay");
			this.spinnableReelsParams.topBorderWidth = 0;
			this.spinnableReelsParams.bottomBorderWidth = 0;
		
		}

		
	}

	


//Panel Colorized merged
class TikiBayPanelFactory implements IPanelFactory
{
    public CreateNewPanel(params: PanelParams):Panel
    {
        return new TikiBayPanel(params);
    }
}

class TikiBayPanel extends Panel
{
    protected override ButtonBackground():ButtonColors
    {
        let color:ButtonColors ={
            backgroundButtonColor: "linear-gradient(rgb(2, 38, 1),rgb(3, 64, 1), rgb(85, 140, 3),rgb(3, 64, 1),rgb(2, 38, 1)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
            linearColor:"linear-gradient(to left , transparent, chartreuse,transparent ) 0 10 100%",
        };
        
        return color;
    }

}
class TikiBayHelpFactory implements IHelpFactory
{
    public CreateNewHelp(params: HelpParameters):Help
    {
        return new   TikiBayHelp(params);
    }
}

class TikiBayHelp extends Help
{
    protected override BackgroundPanel():HelpPanelColor
    {
        let color:HelpPanelColor = {
            backgroundPanelColor: "linear-gradient(rgb(2, 38, 1),rgb(3, 64, 1), rgb(85, 140, 3),rgb(3, 64, 1),rgb(2, 38, 1)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
        };

        return color;
    }
}

	